import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<nb-stat-grid>` — the responsive container for `<nb-stat-card>` (Mockup
 * web.css `.statgrid`).
 *
 * The mockups set an explicit `repeat(N, 1fr)` inline per page; this component
 * defaults to the responsive equivalent — `auto-fit, minmax(200px, 1fr)` with
 * an 18px gap — so cards reflow to fewer columns on narrow viewports without a
 * per-page column count.
 *
 * @example
 * <nb-stat-grid>
 *   <nb-stat-card … />
 *   <nb-stat-card … />
 * </nb-stat-grid>
 */
@Component({
  selector: 'nb-stat-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content />`,
  styleUrl: './stat-grid.css',
})
export class NbStatGrid {}
